module.exports = __webpack_public_path__ + "static/langojango-amharic-language-phrasebook-d9752f7e44dde50a29b49593a9c9b022.png";